// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__kA046","Logo":"Toolbar_Logo__bozME","DesktopOnly":"Toolbar_DesktopOnly__2ReHI"};